import StrongList from './StrongList';

export default StrongList;
